import * as types from '../types.js';

const ICO_DOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 21h18"/><path d="M5 21V10l7-5 7 5v11"/><path d="M9 21v-6h6v6"/><path d="M10 10h4"/></svg>';
const ICO_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20.6 13.4 12 4.8 4 4l.8 8 8.6 8.6a2 2 0 0 0 2.8 0l4.4-4.4a2 2 0 0 0 0-2.8z"/><circle cx="7.5" cy="7.5" r="1"/></svg>';
const ICO_LAYERS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m12 3 9 5-9 5-9-5 9-5z"/><path d="m3 12 9 5 9-5"/><path d="m3 17 9 5 9-5"/></svg>';
const ICO_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
const ICO_NOTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6"/><path d="M8 13h8M8 17h5"/></svg>';

const WEEKDAYS = [
	{ id: 1, label: 'Segunda' },
	{ id: 2, label: 'Terça' },
	{ id: 3, label: 'Quarta' },
	{ id: 4, label: 'Quinta' },
	{ id: 5, label: 'Sexta' },
	{ id: 6, label: 'Sábado' },
	{ id: 7, label: 'Domingo' },
];

const DOCK_TYPES = [
	{ id: 'DRY', label: 'Seca' },
	{ id: 'REFRIGERATED', label: 'Refrigerada' },
	{ id: 'CLIMATE_CONTROLLED', label: 'Climatizada' },
	{ id: 'MIXED', label: 'Mista' },
];

function defaultHours()
{
	return WEEKDAYS.slice(0, 5).map((d) => ({
		weekday: d.id,
		start_time: '08:00',
		end_time: '17:00',
		slot_minutes: 30,
		is_active: true,
	}));
}

function renderHoursRows(tbody, hours)
{
	if (!tbody) return;
	tbody.innerHTML = '';
	(hours || []).forEach((h, idx) =>
	{
		const tr = document.createElement('tr');
		tr.dataset.idx = String(idx);
		const dayOpts = WEEKDAYS.map((d) =>
			`<option value="${d.id}"${Number(h.weekday) === d.id ? ' selected' : ''}>${d.label}</option>`
		).join('');
		const slotOpts = [15, 30, 45, 60].map((s) =>
			`<option value="${s}"${Number(h.slot_minutes) === s ? ' selected' : ''}>${s} min</option>`
		).join('');
		tr.innerHTML = `
			<td><select class="idk-wh-weekday">${dayOpts}</select></td>
			<td class="idk-wh-active-cell"><input type="checkbox" class="idk-wh-active"${h.is_active !== false ? ' checked' : ''}></td>
			<td><input type="time" class="idk-wh-start" value="${(h.start_time || '08:00').toString().slice(0, 5)}"></td>
			<td><input type="time" class="idk-wh-end" value="${(h.end_time || '17:00').toString().slice(0, 5)}"></td>
			<td><select class="idk-wh-slot">${slotOpts}</select></td>
			<td><button type="button" class="button idk-wh-remove" title="Remover janela">✕</button></td>
		`;
		tbody.appendChild(tr);
	});
}

function collectHours(root)
{
	const rows = [...(root?.querySelectorAll('#idk_wh_tbody tr') || [])];
	return rows.map((tr) => ({
		weekday: Number(tr.querySelector('.idk-wh-weekday')?.value || 1),
		is_active: !!tr.querySelector('.idk-wh-active')?.checked,
		start_time: tr.querySelector('.idk-wh-start')?.value || '08:00',
		end_time: tr.querySelector('.idk-wh-end')?.value || '17:00',
		slot_minutes: Number(tr.querySelector('.idk-wh-slot')?.value || 30),
	}));
}

/**
 * Atualiza título, badges e KPIs do painel sial-detail.
 * @param {HTMLElement|null} root
 */
function updateSummary(root)
{
	if (!root) return;
	const setText = (sel, text) =>
	{
		root.querySelectorAll(sel).forEach((el) =>
		{
			el.textContent = text;
		});
	};
	const name = root.querySelector('#name')?.value?.trim() || '';
	const type = root.querySelector('#dock_type')?.value || '';
	const typeLabel = DOCK_TYPES.find((t) => t.id === type)?.label || type || '—';
	const company = root.querySelector('#company_id');
	const companyLabel = company?.selectedOptions?.[0]?.text?.trim()
		|| company?.value
		|| '—';
	const warehouse = root.querySelector('#warehouse_id');
	const warehouseLabel = warehouse?.selectedOptions?.[0]?.text?.trim()
		|| warehouse?.value
		|| '—';
	const classesSel = root.querySelector('#classes');
	const classCount = classesSel ? [...classesSel.options].length : 0;
	const hours = collectHours(root);
	const activeDays = [...new Set(hours.filter((h) => h.is_active).map((h) => h.weekday))];
	const slots = hours.filter((h) => h.is_active).map((h) => h.slot_minutes);
	const commonSlot = slots.length
		? slots.sort((a, b) =>
			slots.filter((v) => v === a).length - slots.filter((v) => v === b).length
		).pop()
		: null;
	const disabled = root.querySelector('#is_disabled')?.checked;

	setText('[data-sdp="title"]', name || 'Nova doca de entrada');
	setText('[data-sdp="company"]', companyLabel);
	setText('[data-sdp="warehouse"]', warehouseLabel);
	setText('[data-sdp="kpi-type"]', typeLabel);
	setText('[data-sdp="kpi-classes"]', classCount === 0 ? 'Todas' : String(classCount));
	setText('[data-sdp="kpi-days"]', activeDays.length ? String(activeDays.length) : '0');
	setText('[data-sdp="kpi-slot"]', commonSlot == null ? '—' : `${commonSlot} min`);

	const badgeActive = root.querySelector('[data-sdp="badge-active"]');
	const badgeDisabled = root.querySelector('[data-sdp="badge-disabled"]');
	if (badgeActive) badgeActive.hidden = !!disabled;
	if (badgeDisabled) badgeDisabled.hidden = !disabled;
}

function syncHoursField(root)
{
	const hidden = root?.querySelector('#working_hours');
	if (hidden) hidden.value = JSON.stringify(collectHours(root));
	updateSummary(root);
}

function bindHoursUi(root)
{
	const tbody = root.querySelector('#idk_wh_tbody');
	const btnAdd = root.querySelector('#idk_wh_add');
	if (!tbody || tbody.dataset.bound === '1') return;
	tbody.dataset.bound = '1';
	btnAdd?.addEventListener('click', () =>
	{
		const hours = collectHours(root);
		hours.push({
			weekday: 1,
			start_time: '08:00',
			end_time: '12:00',
			slot_minutes: 30,
			is_active: true,
		});
		renderHoursRows(tbody, hours);
		syncHoursField(root);
	});
	tbody.addEventListener('click', (ev) =>
	{
		if (!ev.target.classList.contains('idk-wh-remove')) return;
		const tr = ev.target.closest('tr');
		tr?.remove();
		syncHoursField(root);
	});
	tbody.addEventListener('change', () => syncHoursField(root));
}

export default {

	html: `
		<style>
			#input_dock .idk-keymap-row {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-items: stretch;
				gap: 0.65rem;
				width: 100%;
			}
			#input_dock .idk-keymap-row > label.keymap {
				display: flex;
				flex-direction: column;
				flex: 1 1 0;
				min-width: 0;
				margin: 0;
				width: auto;
			}
			#input_dock .idk-keymap-row > span.keymap {
				display: flex;
				flex-direction: column;
				justify-content: center;
				gap: 0.25rem;
				flex: 0 0 auto;
				align-self: center;
			}
			#input_dock .idk-keymap-row select#classes,
			#input_dock .idk-keymap-row select#available {
				width: 100%;
				min-width: 0;
				min-height: 7.5rem;
				box-sizing: border-box;
			}
			#input_dock .idk-wh-toolbar { margin-bottom: 0.5rem; }
			#input_dock .idk-wh-table {
				width: 100%;
				border-collapse: collapse;
				font-size: 0.85rem;
			}
			#input_dock .idk-wh-table th,
			#input_dock .idk-wh-table td {
				border: 1px solid var(--sial-accent-line, #e9d5ff);
				padding: 0.3rem 0.4rem;
			}
			#input_dock .idk-wh-table thead th {
				background: var(--sial-accent-wash, #f3e8ff);
				color: var(--sial-accent, #4c1d95);
				text-align: left;
			}
			#input_dock .idk-wh-active-cell { text-align: center; }
			#input_dock .idk-wh-table select,
			#input_dock .idk-wh-table input[type="time"] { width: 100%; box-sizing: border-box; }
			#input_dock #notes { min-height: 3.5rem; width: 100%; }
		</style>
		<form id="input_dock" class="form sial-modal-form sial-detail sial-detail--edit" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="warehouses"></datalist>
			<input type="hidden" id="working_hours" value="[]">

			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${ICO_DOCK}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Organização · Docas Entrada</p>
						<h2 class="sdp-title" data-sdp="title">Nova doca de entrada</h2>
						<div class="sdp-meta">
							<span>Empresa: <b data-sdp="company">—</b></span>
							<span>Armazém: <b data-sdp="warehouse">—</b></span>
							<span class="sdp-badge sdp-badge--free" data-sdp="badge-active">Ativa</span>
							<span class="sdp-badge sdp-badge--blocked" data-sdp="badge-disabled" hidden>Inativa</span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">×</button>
			</header>

			<section class="sdp-kpis" aria-label="Resumo da doca">
				<div class="sdp-kpi sdp-kpi--total">
					<div class="sdp-kpi-label">${ICO_TAG} Tipo</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-type">—</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--avail">
					<div class="sdp-kpi-label">${ICO_LAYERS} Classes</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-classes">—</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--reserved">
					<div class="sdp-kpi-label">${ICO_CLOCK} Dias ativos</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-days">0</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--free">
					<div class="sdp-kpi-label">${ICO_CLOCK} Slot comum</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-slot">—</span></div>
				</div>
			</section>

			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${ICO_TAG} Identificação</h3>
					<div class="sdp-fields">
						<label title="Empresa">Empresa<sup>*</sup>
							<input id="company_id" type="text" list="companies" required>
						</label>
						<label title="Identificador interno">Código interno
							<input id="id" type="text" disabled>
						</label>
						<label title="Armazém">Armazém<sup>*</sup>
							<input id="warehouse_id" type="text" list="warehouses" required>
						</label>
						<label title="Nome da doca">Nome<sup>*</sup>
							<input id="name" type="text" required maxlength="120">
						</label>
						<label title="Tipo da doca">Tipo<sup>*</sup>
							<select id="dock_type" required>
								<option value="DRY">Seca</option>
								<option value="REFRIGERATED">Refrigerada</option>
								<option value="CLIMATE_CONTROLLED">Climatizada</option>
								<option value="MIXED">Mista</option>
							</select>
						</label>
					</div>
					<div class="sdp-check-row">
						<label title="Doca inativa não entra na disponibilidade futura">
							<input id="is_disabled" type="checkbox"> Inativa
						</label>
					</div>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${ICO_NOTE} Observações</h3>
					<div class="sdp-fields">
						<label class="sdp-span-2" title="Observações">Observações
							<textarea id="notes" maxlength="2000"></textarea>
						</label>
					</div>
					<p class="sdp-hint">Texto livre para a operação (ex.: restrições físicas da doca).</p>
				</div>
			</section>

			<div class="sdp-stack">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${ICO_LAYERS} Classes aceitas</h3>
					<p class="sdp-hint">Sem classes selecionadas = doca aceita todas as classes.</p>
					<div class="idk-keymap-row">
						<label class="keymap">Classes<select id="classes" multiple size="5"></select></label>
						<span class="keymap">
							<button type="button" class="bn_Left" title="Incluir">&#x1F844;</button>
							<button type="button" class="bn_Right" title="Remover">&#x1F846;</button>
						</span>
						<label class="keymap">Disponíveis<select id="available" multiple size="5"></select></label>
					</div>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${ICO_CLOCK} Horário de funcionamento</h3>
					<p class="sdp-hint">Usado para calcular disponibilidade no agendamento de recebimento.</p>
					<div class="idk-wh-toolbar">
						<button type="button" class="button" id="idk_wh_add">Adicionar janela</button>
					</div>
					<table class="idk-wh-table">
						<thead>
							<tr>
								<th>Dia</th>
								<th>Ativo</th>
								<th>Início</th>
								<th>Fim</th>
								<th>Slot</th>
								<th></th>
							</tr>
						</thead>
						<tbody id="idk_wh_tbody"></tbody>
					</table>
				</div>
			</div>

			<div class="sdp-foot">
				<button class="bn_Escape button">Fechar</button>
				<button class="bn_Enter button">Salvar</button>
			</div>
		</form>
	`,

	form: {
		selector: '#input_dock',
		init(formset)
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			const root = document.querySelector('#input_dock');
			bindHoursUi(root);
			renderHoursRows(root?.querySelector('#idk_wh_tbody'), defaultHours());
			syncHoursField(root);
			root?.querySelector('.bn_Enter')?.addEventListener('click', () => syncHoursField(root), true);
			root?.addEventListener('input', () => updateSummary(root));
			root?.addEventListener('change', () => updateSummary(root));
			Object.getPrototypeOf(this).init.call(this);
			updateSummary(root);
		},
		afterEditSetValues(fs, data)
		{
			const root = document.querySelector('#input_dock');
			const hours = data?.working_hours?.length ? data.working_hours : defaultHours();
			renderHoursRows(root?.querySelector('#idk_wh_tbody'), hours);
			syncHoursField(root);
			updateSummary(root);
			setTimeout(() => updateSummary(root), 400);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{
			properties: { selector: '#warehouse_id' },
			types: [
				types.pubsub(),
				types.datalist(),
				types.observer('company_id'),
				types.obs_load_options('warehouses', { labels: ['name'] }),
			],
		},
		{ properties: { selector: '#name' }, types: [] },
		{ properties: { selector: '#dock_type' }, types: [] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
		{ properties: { selector: '#notes' }, types: [] },
		{ properties: { selector: '#working_hours' }, types: [] },
		{
			properties: { selector: '#classes' },
			types: [
				types.pubsub(),
				types.keymap('classes', '#available', { values: ['company_id', 'id'] }),
				types.observer('company_id'),
				types.obs_load_keymap(),
			],
		},
	],
};
